import { motion } from "framer-motion";

function Preloader({ load }) {
  return (
    <div
      id={load ? "preloader" : "preloader-none"}
      className="transition-opacity duration-700"
    >
      {load && (
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="flex flex-col items-center justify-center space-y-4"
        >
          <motion.div
            animate={{
              rotate: 360,
            }}
            transition={{
              duration: 1,
              repeat: Infinity,
              ease: "linear",
            }}
            className="w-16 h-16 border-4 border-purple-600 border-t-transparent rounded-full"
          />
          <motion.h1
            animate={{
              opacity: [0.5, 1, 0.5],
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="text-2xl font-bold text-gradient"
          >
            Loading...
          </motion.h1>
        </motion.div>
      )}
    </div>
  );
}

export default Preloader;
